import { BatchesCollection, TriState } from '../BatchesList/typings';

import { GetCommonCreativesResponse } from './typings';

export function createCreativesCollection(response: GetCommonCreativesResponse): BatchesCollection {
    return {
        batches: response.items.map(batch => {
            const batchItems = batch.items
                .filter(item => item.available)
                .map(item => {
                    return {
                        id: item.id,
                        name: item.name,
                        batchId: item.batchId,
                        creativeURL: item.creativeURL,
                        screenshotURL: item.screenshotURL,
                        previewURL: item.previewURL,
                        archiveURL: '',
                        selected: false,
                        fitsSizeFilter: true,
                        data: {
                            width: item.data.width,
                            height: item.data.height,
                            isAdaptive: item.data.options.isAdaptive
                        }
                    };
                });

            return {
                id: batch.id,
                thumbnail: batch.items[0].screenshotURL,
                selected: TriState.FALSE,
                name: batch.name,
                total: batchItems.length,
                filteredBySizeTotal: batchItems.length,
                items: batchItems
            };
        }),
        total: response.total
    };
}
